export const mintsOptions = Array.from({ length: 59 }, (_, i) => i + 1);
export const hoursOptions = Array.from({ length: 24 }, (_, i) => i + 1);
export const daysOptions = Array.from({ length: 31 }, (_, i) => i + 1);
export const weeksOptions = Array.from({ length: 52 }, (_, i) => i + 1);
